module.exports = __webpack_public_path__ + "img/kz.00ca7b59.jpg";